(function (window, document, $, undefined) {
  // Mobile Menu Toggle
  $(".menu-button").click(function () {
    $(this).toggleClass("active");
    $(".menu-mobile .menuNavContainer").stop().slideToggle();
  });

  //Homepage Slider
  $(".jsHomeSlider").each(function () {
    var $slider = $(this);
    var $nav = 
    $(this)
    .parent()
    .parent()
    .find('.jsNavArrow'); 

    $slider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      cssEase: 'ease',
      speed: 1000,
      responsive: [
        {
          breakpoint: 995,
          settings: {
            autoplay: true,
            autoplaySpeed: 2000,
          }
        }
      ]
    });

    $nav.on("click", function (e) {
      e.preventDefault();
      $slider.slick($(this).data("dir"));
    });
  });

  $(document).ready(function () {
    $('.cp .slides > li').fadeIn(400);
    $('.jsHomeSlider').fadeIn(500);
  });

})(window, document, jQuery);
